import { render, staticRenderFns } from "./LandingInputLeft.vue?vue&type=template&id=98f3aa20&scoped=true&"
import script from "./LandingInputLeft.vue?vue&type=script&lang=js&"
export * from "./LandingInputLeft.vue?vue&type=script&lang=js&"
import style0 from "./LandingInputLeft.vue?vue&type=style&index=0&id=98f3aa20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f3aa20",
  null
  
)

export default component.exports